import React from 'react'

import FacebookIcon from 'svgs/facebook.svg'
import TwitterIcon from 'svgs/twitter.svg'
import InstagramIcon from 'svgs/instagram.svg'
import YoutubeIcon from 'svgs/youtube.svg'
import TikTokIcon from 'svgs/tik-tok.svg'
// import SpotifyIcon from 'svgs/spotify.svg'

const Social = ({ inMenu }) => {
  const inMenuStyles = `mt-8 overflow-y-hidden`
  const desktopStyles = `hidden md:block fixed top-[45%] right-0 flex flex-cols bg-black z-[99999] py-3 p-2 gap-3`
  return (
    <div className={inMenu ? inMenuStyles : desktopStyles}>
      <div
        className={
          inMenu
            ? 'fade-up flex w-full items-center justify-center gap-8 '
            : 'flex flex-col gap-4'
        }
      >
        {/* <a href="/" target="_blank" rel="noopener noreferrer">
          <span className="sr-only">Facebook</span>
          <FacebookIcon className="pointer w-[28px] h-[28px] fill-white hover:fill-gold" />
        </a> */}
        <a
          href="https://twitter.com/dorothymusical?s=21&t=shq9gXI9cGO4lB1qS6nIKw"
          target="_blank"
          rel="noopener noreferrer"
        >
          <span className="sr-only">Twitter</span>
          <TwitterIcon className="pointer w-[28px] h-[28px] fill-white hover:fill-gold" />
        </a>
        <a
          href="https://www.instagram.com/DorothyDandridgethemusical/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <span className="sr-only">Instagram</span>
          <InstagramIcon className="pointer w-[28px] h-[28px] fill-white hover:fill-gold" />
        </a>
        {/* <a href="/" target="_blank" rel="noopener noreferrer">
          <span className="sr-only">Youtube</span>
          <YoutubeIcon className="pointer w-[28px] h-[28px] fill-white hover:fill-gold" />
        </a> */}
        <a
          href="https://www.tiktok.com/@dorothythemusical"
          target="_blank"
          rel="noopener noreferrer"
        >
          <span className="sr-only">TikTok</span>
          <TikTokIcon className="pointer w-[28px] h-[28px] fill-white hover:fill-gold" />
        </a>
        {/* <a
      href=""
      target="_blank"
      rel="noopener noreferrer"
    >
      <span className="sr-only">Spotify</span>
      <SpotifyIcon className="pointer" />
    </a> */}
      </div>
    </div>
  )
}

export default Social
